import CLECoursesSearchController from "controllers/cle_courses_search_controller"

export default class extends CLECoursesSearchController {
  static values = {
    ...super.values,
    jurisdictionName: String
  }

  searchOptions() {
    const options = super.searchOptions()

    return {
      ...options,
      facets: {
        ...options.facets,
        jurisdictions: false
      },
      jurisdictionName: this.jurisdictionNameValue
    }
  }
}
